// Language bridge for web app
// This integrates the Electron menu language changes with NIRV.L system

(function() {
  // Initialize when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initLanguageBridge);
  } else {
    initLanguageBridge();
  }

  function initLanguageBridge() {
    // Hook into the existing NIRV preference system
    if (typeof NIRV !== 'undefined' && NIRV.handlePreferenceChange) {
      const originalHandlePreferenceChange = NIRV.handlePreferenceChange;
      
      NIRV.handlePreferenceChange = function(key, value) {
        // Call original handler first
        originalHandlePreferenceChange.call(this, key, value);
        
        // If language changed, sync with main process
        if (key === 'UILanguage' && window.electronLanguage) {
          window.electronLanguage.changeLanguage(value).then((result) => {
            if (result.success) {
              console.log('Main process language updated to:', value);
            } else {
              console.error('Failed to update main process language:', result.error);
            }
          }).catch((error) => {
            console.error('Error updating main process language:', error);
          });
        }
      };
    }

    // Initialize main process language with current web language
    if (window.electronLanguage && typeof NIRV !== 'undefined') {
      // Get current language from i18next or preferences
      let currentLang = 'en'; // default
      
      // Check i18next first
      if (window.NirvanaI18next && window.NirvanaI18next.getCurrentLanguage) {
        currentLang = window.NirvanaI18next.getCurrentLanguage();
      }
      // Or check if there's a UILanguage preference
      else if (NIRV.prefs && NIRV.prefs.UILanguage && NIRV.prefs.UILanguage.value) {
        currentLang = NIRV.prefs.UILanguage.value;
      }

      window.electronLanguage.initLanguage(currentLang).then((mainLang) => {
        console.log('Language bridge initialized. Web:', currentLang, 'Main:', mainLang);
      }).catch((error) => {
        console.error('Error initializing language bridge:', error);
      });
    }
  }
})();
